<template>
  <DMModal name="faqs" :width="600">
    <div slot-scope="{ params }" v-if="params !== false">
      <h2 class="mb-3 text-lg">{{ params.faqs[params.index].question }}</h2>
      <ul class="list-disc pl-6">
        <li v-for="answer in answers(params.faqs[params.index].answer)">
          {{ answer }}
        </li>
      </ul>
    </div>
  </DMModal>
</template>

<script>
import DMModal from '@components/DMModal';

export default {
  name: 'FaqsModal',
  components: { DMModal },

  data() {
    return {
      confirm: false,
    };
  },

  methods: {
    answers(answers) {
      return answers.split('\n');
    },
  },
};
</script>

<style scoped></style>
[{"value": null, "answer": "DesignMorphine recognizes that passion for design has no boundaries and we are focused on
building a multidisciplinary mindset and techniques that can be applied to any design field. We aim to prepare the new
generation of designers not only to expand their horizons and stay relevant but to thrive and drive progress and change.
Especially when we are all facing unprecedented trying times of great uncertainty.", "question": "Why is this the Master
for you?"}, {"value": null, "answer": "Graduate in only 9 months with a Master's of Science Degree in Computational and
Advanced Design\nEarn a degree accredited and worldwide recognized\nMaster an exclusive design mindset through proven
successful methods of accelerated learning\nLead design innovation by immersing yourself in the world of
multidisciplinary advanced and computational design\nBecome a part of a diverse community with a global network\nDevelop
a holistic design ethos and skill-set that can be applied in any design industry\nBuild your own design brand or be the
ideal candidate for any advanced or computational design position world wide\nLearn from the best! Exceptional
educational team of leaders including designers, architects and mentors with diverse background from industry leading
companies and eminent educational institutions\nExperience the freedom of online education and enjoy all its
advantages", "question": "What does DesignMorphine Masters offer?"}, {"value": null, "answer": "Democratizing knowledge
by eliminating physical boundaries\nFull access of our exceptional network of eminent educators\nFlexibility in learning
with live and pre-recorded sessions\nAccelerated and focused methods of online learning\nAffordable pricing in high
education", "question": "Why Online Masters?"}, {"value": null, "answer": "Formulating a concrete theoretical frame to
support your vision\nImportance of topology and advantages of procedural modelling and non-destructive reversible
workflows\nInteroperability workflows and optimization of design processes\nPolygonal Modelling and Sculpting with Maya
and ZBrush\nNurbs & SubD Modelling with Rhino\nComputational and generative design with Grasshopper and Houdini\nData
driven morphing systems\nAnimation and Rigging techniques\nVisual Coding\nVirtualization with VRay and Post-production
with Photoshop\nCreating VR experiences with Unreal Engine\nSwarm robotics with Arduino\nPrototyping techniques such as
3D Printing, Laser-cutting, CNC milling, Vacuum forming", "question": "What should I expect to learn?"}, {"value": null,
"answer": "Autodesk Maya\nPixologic ZBrush\nRhinoceros 6.0\nGrasshopper Plugins: Pufferfish, Weaverbird, MeshEdit,
Mesh+, Lunchbox, Milepede, Wasp, Quelea, Dendro, Human, Open Nest, Squid, Firefly\nHoudini\nUnreal
Engine\nShapeDiver\nPepakura\nVRay\nKeyshot\nAdobe Creative Suite\nAdobe Photoshop CS6 +\nArduino
IDE\nProcessing\nFritzing\nAtom/Brackets/Notepad++xxx", "question": "Which Software should I expect to learn?"},
{"value": null, "answer": "Architectural Association School of Architecture Design Research laboratory: AADRL\nHarvard
Graduate School of Design: GSD\nUniversity College London: the Bartlett\nInstitute for Advanced Architecture of
Catalonia: IAAC\nUniversity of Applied Arts Vienna: die Angewandte\nCenter for Information Technology and Architecture:
CITA\nNew York Institute of Technology: NYIT\nTechnical University Vienna: TU Wien\nTechnical University of Delft: TU
Delft\nNational Technical University of Athens: NTUA\nUniversity of Architecture Civil Engineering and Geodesy:
UACEG\nCornell University\nICD Stuttgart\nThe City College of New York\nThe University of Hong Kong", "question": "With
which universities has the DesignMorphine team have affiliations with?"}, {"value": null, "answer": "Zaha Hadid
Architects\nFoster+Partners\nBIG\nBIG Ideas\nNike\nReebok\nSamsonite\nAutodesk\nCoop
Himmelb[l]au\nGrimshaw\nGensler\nPopulous\nTrahan Architects\nLaguarda.Low Architects\nPlayerunknown's Battlegrounds",
"question": "What is DesignMorphine's team's collective professional design experience?"}, {"value": null, "answer":
"Architecture\nInterior Design\nIndustrial Design\nProduct Design\nFootwear Design\nFashion Design\nJewelry
Design\nVehicle Design\nTransportation\nUrban Design\nLandscape Design\nAnimation\nGaming Industry", "question": "In
which fields can I seek work opportunities after completing the program?"}, {"value": null, "answer": "Fearless creative
drive\nUnique design philosophy\nPassion, perseverance and motivation\nIntegrity, strong work ethic and team
spirit\nInnovative trans-disciplinary design work\nStrong communication skills\nDiversified and multi-scalar design
background\nCreative problem-solving abilities\nAnalytical theoretical approach\nDetermination to carve one's own design
path\nOptional professional design and/or educational experience", "question": "What are the selection criteria for
successful applicants?"}, {"value": null, "answer": "No previous computational design experience is required. However,
prior knowledge in 3D design programs, such as Rhino or/and Maya, is welcome.", "question": "Do I need previous
experience in computational design to apply?"}, {"value": null, "answer": "The program is full-time. Due to the fact
that it is online, it allows for some flexibility. Still, full-time employment is discouraged since it's going to
reflect on the student's performance.", "question": "Can I be a student in the program and work at the same time?"},
{"value": null, "answer": "Yes. Our Partner University, the UACEG, is offering affordable student accommodation in
Sofia, Bulgaria for EU students for approximately €150 - €400 per month.", "question": "Does DesignMorphine offer
Student Accommodation?"}, {"value": null, "answer": "Yes. The insurance cost is covered separately.", "question": "Does
DesignMorphine offer Health Insurance?"}, {"value": null, "answer": "No. A visa is not required.", "question": "Do I
need a VISA to apply?"}, {"value": null, "answer": "The following figures should be used only as a guideline:\n\nLiving
expenses: The program is online and there are no additional living expenses out of your regular lifestyle.\nProto Lab
expenses: The program is geared towards the virtual experience, so expectations of model making will be minimal to
none.\nRobo Lab expenses: Students will learn how to develop and build multifunctional small robots reacting to specific
conditions and rules. The cost of materials will be approximately €320. This figure is subject to change based on your
location.\nOptional Study Trip: You are not obligated to participate in the trip. Travel expenses will mainly depend on
your proximity to the city we will be visiting and your accommodation choice.", "question": "What additional expenses
should I expect?"}]
